import styled from '@emotion/styled';
import { Button, Modal } from 'antd';
import type { Immutable } from 'immer';
import { type FC, useState } from 'react';
import { useStore } from 'src/store/reducers';
import type { ManagedTracker } from 'src/store/trackers/trackers_reducers';
import { HStack } from '../MetaComponent';
import { TagSelect } from '../TagSelect/TagSelect';
import { TrackerUpdateCount } from '../TrackerUpdateCount';

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  trackers: Immutable<Array<ManagedTracker>>;
}

export const AddOrSelectTagModal: FC<Props> = ({ isModalOpen, setIsModalOpen, trackers }) => {
  const [selectedTag, setSelectedTag] = useState<string | null>(null);
  const { updateOrCreateTrackerTag } = useStore((s) => s.trackers.actions);

  return (
    <Modal
      width={300}
      title="Add or Select Tag"
      footer={
        <StyledFooter>
          <TrackerUpdateCount targetTrackers={trackers} total={trackers.length} />
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              updateOrCreateTrackerTag(selectedTag, trackers);
              setIsModalOpen(false);
            }}
            disabled={!selectedTag}
          >
            Add
          </Button>
        </StyledFooter>
      }
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      afterClose={() => setSelectedTag(null)}
      destroyOnClose
    >
      <TagSelect setSelectedTag={setSelectedTag} />
    </Modal>
  );
};

const StyledFooter = styled(HStack)`
  width: 100%;
`;
